module.exports = __webpack_public_path__ + "static/media/arrow-dot.c610387d.svg";